import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GetVatRatesService } from './get-vat-rates/get-vat-rates.service';

@NgModule({
  imports: [CommonModule],
  providers: [
    GetVatRatesService
  ],
})
export class VatRatesModule {}
